// TSS vite/03 §"Query keys convention".

export const billingKeys = {
    all:         ['billing'],
    managements: (filters) => ['billing', 'managements', filters],
    lines:       (id)      => ['billing', 'management-lines', id],
    costs:       (filters) => ['billing', 'costs', filters],
    tariffs:     (mgmtId)  => ['billing', 'tariffs', mgmtId],
    stays:       (animalId) => ['billing', 'stays', animalId],
    batches:     (filters) => ['billing', 'batches', filters],
    batch:       (id)      => ['billing', 'batch', id],
    cowLiq:      (animalId, y, m) => ['billing', 'cow-liq', animalId, y, m],
    account:     (client, range) => ['billing', 'account', client, range],
    payments:    (filters) => ['billing', 'payments', filters],
};
